module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Volume One")]), _vm._v(" "), _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "Volume One"
    }
  }, [_c('h1', {
    staticClass: "txc",
    attrs: {
      "id": "a_12"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/contents#b_2",
      "id": "a_1"
    }
  }, [_vm._v("Volume "), _c('br'), _vm._v(" One")])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('img', {
    staticClass: "maxwidth",
    attrs: {
      "alt": "",
      "id": "p0007-d6e20",
      "role": "presentation",
      "src": "images/978141857365_0007_002.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  })]), _c('a', {
    attrs: {
      "id": "page7"
    }
  })]), _c('a', {
    attrs: {
      "id": "page7"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page7"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbe32110","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 78
// module chunks = 0